module.exports = __webpack_public_path__ + "static/img/C4D0010.6d962d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0010.jpg
// module id = UjDn
// module chunks = 0